<template>
  <div class="popup-main">
    <el-dialog
      :title="detailId ? '编辑生产工单' : '新增生产工单'"
      width="1010px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="box-y-scroll" :style="{ 'max-height': maxHeight }">
        <e-form ref="refForm" :column="formColumn" :data.sync="selfData.formData" />
        <div v-if="selfData.tableSaleData.length">
          <div class="group-title m-t-10">工艺路线</div>
          <div class="m-t-10">
            <GongyiLine
              :data="selfData.tableSaleData[0]"
              :isShowBom="false"
              :isShowAll="false"
              isSource
            />
          </div>
          <div class="group-title m-t-20">物料清单</div>
          <div class="m-t-10">
            <TableWuliao :data.sync="selfData.wuliaoData" />
          </div>
          <div class="group-title m-t-20">工艺详情</div>
          <div class="m-t-10">
            <TableGongyi :data.sync="selfData.gongyiData" />
          </div>
          <div class="group-title m-t-20">成品</div>
          <div class="m-t-10">
            <TableChengpin :list="selfData.tableSaleData" />
          </div>
          <div class="group-title m-t-20">质检要求</div>
          <div class="m-t-10">
            <table class="zhijian-table">
              <thead>
                <tr>
                  <th width="60">序号</th>
                  <th>检测项目</th>
                  <th>标准范围</th>
                  <th>实测范围</th>
                  <th>检测结果</th>
                  <th width="120">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in selfData.zhi_jian_yao_qiu_list" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td><el-input v-model="item.jian_ce_xiang_mu" size="mini" /></td>
                  <td><el-input v-model="item.biao_zhun_fan_wei" size="mini" /></td>
                  <td><el-input v-model="item.shi_ce_fan_wei" size="mini" /></td>
                  <td><el-input v-model="item.jian_ce_jie_guo" size="mini" /></td>
                  <td>
                    <el-link type="success" @click="addZhijian(index)">增行</el-link>
                    <el-link
                      v-if="selfData.zhi_jian_yao_qiu_list.length > 2"
                      class="m-l-10"
                      type="danger"
                      @click="removeZhijian(index)"
                      >删行</el-link
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" @click="popupConfirm(true)">打印预览</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {
    GongyiLine: () => import('@/components/business/b-popup-verify-goods-view/view-item'),
    TableWuliao: () => import('./table-wuliao'),
    TableGongyi: () => import('./table-gongyi'),
    TableChengpin: () => import('./table-chengpin')
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    billId: {
      type: [Number, String],
      default: ''
    },
    jiagongId: {
      type: [Number, String],
      default: ''
    },
    detailId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      selfShow: false,
      // 全部设备原始选项（供班组联动过滤使用）
      allShebeiOptions: [],
      selfData: {
        formData: {
          id: '',
          gong_dan_code: '',
          bill_id: '',
          bill_code: '',
          gong_cheng_fu_ze_ren_name: '',
          pmc_fu_ze_ren_name: '',

          banzu_id: '',
          banzu_name: '',
          sheng_chan_ren_yuan_id: '',
          sheng_chan_ren_yuan_name: '',
          shebei_id: '',
          jiao_huo_ri_qi: '',
          sheng_chan_end_date: '',
          pai_dan_date: '',
          check_stock2_id: '',
          current_gong_xu_id: ''
        },
        tableSaleData: [],
        wuliaoData: [],
        gongyiData: {},
        zhi_jian_yao_qiu_list: []
      },
      formColumn: [
        {
          type: 'text',
          title: '工单编码',
          field: 'gong_dan_code',
          disabled: true,
          placeholder: '自动生成'
        },
        {
          type: 'text',
          title: '销售单号',
          field: 'bill_code',
          disabled: true
        },
        {
          type: 'text',
          title: '工程负责人',
          field: 'gong_cheng_fu_ze_ren_name',
          disabled: true
        },
        {
          type: 'text',
          title: 'PMC负责人',
          field: 'pmc_fu_ze_ren_name',
          disabled: true
        },
        {
          type: 'select',
          title: '生产班组',
          field: 'banzu_id',
          options: [],
          fnChange: () => {
            this.banzuChange()
          }
        },
        {
          type: 'select',
          title: '生产人员',
          field: 'sheng_chan_ren_yuan_id',
          options: [],
          fnChange: () => {
            this.shengChanRenYuanChange()
          }
        },
        {
          type: 'select',
          title: '设备',
          field: 'shebei_id',
          options: []
        },
        {
          type: 'date',
          title: '订单交期',
          field: 'jiao_huo_ri_qi'
        },
        {
          type: 'date',
          title: '生产交期',
          field: 'sheng_chan_end_date'
        },
        {
          type: 'datetime',
          title: '派单日期',
          field: 'pai_dan_date',
          format: 'yyyy-MM-dd HH:mm:ss',
          valueFormat: 'yyyy-MM-dd HH:mm:ss'
        }
      ]
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  computed: {
    maxHeight() {
      return `${this.$util.getViewHeight() - 280}px`
    }
  },
  async mounted() {
    this.selfShow = this.show
    await this.getSheBeiListData()
    await this.getBanzuList()
    if (this.detailId) {
      await this.getDetailData()
    } else {
      await this.getPmcDetailData()
    }
    // 根据已选班组联动过滤设备下拉选项（不清空已选值，供编辑回填使用）
    this.updateShebeiOptionsByBanzu(this.selfData.formData.banzu_id)
    // 编辑时，加载班组成员列表
    if (this.selfData.formData.banzu_id) {
      this.getBanzuDetail(this.selfData.formData.banzu_id)
    }
  },
  methods: {
    // 获取详情数据
    async getDetailData() {
      await this.$api({
        method: 'get',
        url: '/admin/gcvip/shengChanGongDan/detail',
        params: {
          id: this.detailId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data)
          this.selfData = {
            formData: {
              ...this.selfData.formData,
              ...result.formData
            },
            tableSaleData: result.tableSaleData,
            wuliaoData: this.getWuliaoData(result.tableSaleData[0]),
            gongyiData: result.gongyiData,
            zhi_jian_yao_qiu_list: result.zhi_jian_yao_qiu_list || this.getDefaultZhijianList()
          }
        }
      })
    },
    // 获取pmc详情数据
    async getPmcDetailData() {
      await this.$api({
        method: 'get',
        url: '/admin/gcvip/shengChanGongDan/findByBillIdAndGongyiId',
        params: {
          billId: this.billId,
          gongyiId: this.jiagongId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data)
          // 新增弹窗：派单日期为空或空字符串时，默认当前年月日时分秒
          let pai_dan_date = result.formData.pai_dan_date
          if (!pai_dan_date) {
            pai_dan_date = this.$XEUtils.toDateString(this.$XEUtils.now(), 'yyyy-MM-dd HH:mm:ss')
          }
          this.selfData = {
            formData: {
              ...this.selfData.formData,
              ...result.formData,
              bill_id: result.formData.id,
              check_stock2_id: result.tableSaleData[0].id,
              current_gong_xu_id: this.jiagongId,
              pai_dan_date
            },
            tableSaleData: result.tableSaleData,
            wuliaoData: this.getWuliaoData(result.tableSaleData[0]),
            gongyiData: result.gongyiData,
            zhi_jian_yao_qiu_list: this.getDefaultZhijianList()
          }
        }
      })
    },
    getWuliaoData(data) {
      let result = []
      if (data.tableBomData.length) {
        result = data.tableBomData || []
      } else {
        if (data.table_data_2.length) {
          result = data.table_data_2 || []
        } else {
          result = data.table_data_1 || []
        }
      }
      return this.$util.deepCopy(result)
    },
    // 获取默认质检要求列表（2行空数据）
    getDefaultZhijianList() {
      return [
        { jian_ce_xiang_mu: '', biao_zhun_fan_wei: '', shi_ce_fan_wei: '', jian_ce_jie_guo: '' },
        { jian_ce_xiang_mu: '', biao_zhun_fan_wei: '', shi_ce_fan_wei: '', jian_ce_jie_guo: '' }
      ]
    },
    // 添加质检要求行（在指定位置后插入）
    addZhijian(index) {
      this.selfData.zhi_jian_yao_qiu_list.splice(index + 1, 0, {
        jian_ce_xiang_mu: '',
        biao_zhun_fan_wei: '',
        shi_ce_fan_wei: '',
        jian_ce_jie_guo: ''
      })
    },
    // 删除质检要求行（保留最少2行）
    removeZhijian(index) {
      if (this.selfData.zhi_jian_yao_qiu_list.length <= 2) return
      this.selfData.zhi_jian_yao_qiu_list.splice(index, 1)
    },
    // 获取班组列表
    getBanzuList() {
      return this.$api({
        method: 'post',
        url: '/admin/gcvip/banzu/list',
        data: {
          currentPage: 1,
          pageSize: this.$constant.pageMax,
          sortData: { id: 'desc' }
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let result = res.data.page.list.map((item) => {
              return {
                key: item.name,
                val: item.id,
                disabled: item.status === false
              }
            })
            // 班组下拉直接展示全部班组
            this.formColumn.forEach((item) => {
              if (item.field === 'banzu_id') item.options = result
            })
          }
        })
        .catch(() => {})
    },
    // 获取班组详情（含成员列表）
    getBanzuDetail(id) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/banzu/detail',
        params: { id }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let cheng_yuan_list = res.data.form_data.cheng_yuan_list || []
            let options = cheng_yuan_list.map((item) => {
              return {
                key: item.yuan_gong_user_name,
                val: item.yuan_gong_id
              }
            })
            this.formColumn.forEach((item) => {
              if (item.field === 'sheng_chan_ren_yuan_id') item.options = options
            })
          }
        })
        .catch(() => {})
    },
    // 根据选中班组更新设备下拉选项（严格联动：未选班组或班组未绑定设备时下拉为空，不清空已选值供编辑回填）
    updateShebeiOptionsByBanzu(banzu_id) {
      let shebeiOptions = []
      if (banzu_id) {
        // 仅展示绑定了该班组的设备，无匹配设备时严格为空
        shebeiOptions = this.allShebeiOptions.filter((opt) =>
          (opt.banzu_ids || []).includes(banzu_id)
        )
      }
      this.formColumn.forEach((item) => {
        if (item.field === 'shebei_id') item.options = shebeiOptions
      })
    },
    // 班组选择变化-联动加载生产人员并过滤设备下拉
    banzuChange() {
      let banzu_id = this.selfData.formData.banzu_id
      // 更新班组名称
      this.formColumn.forEach((item) => {
        if (item.field === 'banzu_id') {
          let selected = item.options.find((opt) => opt.val === banzu_id)
          this.selfData.formData.banzu_name = selected ? selected.key : ''
        }
      })
      // 清空已选生产人员
      this.selfData.formData.sheng_chan_ren_yuan_id = ''
      this.selfData.formData.sheng_chan_ren_yuan_name = ''
      // 获取班组成员列表
      if (banzu_id) {
        this.getBanzuDetail(banzu_id)
      } else {
        this.formColumn.forEach((item) => {
          if (item.field === 'sheng_chan_ren_yuan_id') item.options = []
        })
      }
      // 根据班组过滤设备下拉，并清空已选设备
      this.updateShebeiOptionsByBanzu(banzu_id)
      this.selfData.formData.shebei_id = ''
    },
    // 生产人员选择变化-更新名称
    shengChanRenYuanChange() {
      let sheng_chan_ren_yuan_id = this.selfData.formData.sheng_chan_ren_yuan_id
      this.formColumn.forEach((item) => {
        if (item.field === 'sheng_chan_ren_yuan_id') {
          let selected = item.options.find((opt) => opt.val === sheng_chan_ren_yuan_id)
          this.selfData.formData.sheng_chan_ren_yuan_name = selected ? selected.key : ''
        }
      })
    },
    // 获取设备列表（option 中保留设备绑定的班组 ids，用于联动）
    getSheBeiListData() {
      return this.$api({
        method: 'post',
        url: '/admin/gcvip/sheBei/list',
        data: {
          currentPage: 1,
          pageSize: this.$constant.pageMax,
          sortData: { id: 'desc' }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            let result = res.data.page.list.map((item) => {
              return {
                key: item.name,
                val: item.id,
                banzu_ids: item.banzu_ids || [],
                disabled: item.status === false
              }
            })
            // 仅缓存全部设备原始选项供班组联动过滤，下拉初始为空（需先选择班组）
            this.allShebeiOptions = result
          }
        })
        .catch(() => {})
        .then(() => {})
    },
    // 项-打印预览（保存成功后调用）
    itemPrint(id) {
      window.open(`/new/renwu/print?id=${id}`, '_blank')
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认（isPrint 为 true 时保存成功后打印预览）
    popupConfirm(isPrint = false) {
      let { formData, gongyiData } = this.selfData
      let wuliaoData = this.selfData.wuliaoData.map((item) => {
        let result = {
          id: item.id,
          tabletype: item.tabletype,
          warehuose_name: item.warehuose_name,
          get_counts: item.get_counts
        }
        return result
      })
      let form_data = {
        bill_id: formData.bill_id,
        check_stock2_id: formData.check_stock2_id,
        current_gong_xu_id: formData.current_gong_xu_id,
        shebei_id: formData.shebei_id,
        banzu_id: formData.banzu_id,
        banzu_name: formData.banzu_name,
        sheng_chan_ren_yuan_id: formData.sheng_chan_ren_yuan_id,
        sheng_chan_ren_yuan_name: formData.sheng_chan_ren_yuan_name,
        jiao_huo_ri_qi: formData.jiao_huo_ri_qi,
        sheng_chan_end_date: formData.sheng_chan_end_date,
        pai_dan_date: formData.pai_dan_date,
        wuliaoData,
        gongyiData: this.$util.deepCopy(gongyiData),
        zhi_jian_yao_qiu_list: this.selfData.zhi_jian_yao_qiu_list
      }
      if (this.detailId) form_data.id = this.detailId
      this.$api({
        method: 'post',
        url: '/admin/gcvip/shengChanGongDan/saveOrUpdate',
        data: {
          form_data
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            // 新增时取后端返回的 id，编辑时兜底用 detailId
            let printId = res.data.id || this.detailId
            this.popupCancel()
            this.$emit('success')
            this.$message.success('保存成功')
            if (isPrint === true) this.itemPrint(printId)
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}

.zhijian-table {
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #ebeef5;
    padding: 4px;
    font-size: 12px;
    text-align: center;
  }

  th {
    font-weight: bold;
    background: #f5f7fa;
  }

  /deep/ .el-input {
    width: 100%;
  }
}
</style>
